import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '../constants/window';

@Injectable({
  providedIn: 'root',
})
export class JwtService {
  private _jsonWebToken: string = '';
  public get jsonWebToken(): string {
    return this._jsonWebToken;
  }
  public set jsonWebToken(tokenValue: string) {
    if (tokenValue) {
      this._jsonWebToken = tokenValue;
    }
  }

  private _decodedJsonWebToken: { [key: string]: string } = {};
  public get decodedJsonWebToken(): { [key: string]: string } {
    this._decodedJsonWebToken = this.jsonWebToken
      ? JSON.parse(this._window.atob(this.jsonWebToken.split('.')[1])) // jwt_decode(this.JsonWebToken) can be replaced here when used 'jwt-token' 3rd party library
      : null;
    return this._decodedJsonWebToken;
  }
  public set decodedJsonWebToken(decodedTokenValue: { [key: string]: string }) {
    if (decodedTokenValue) {
      this._decodedJsonWebToken = decodedTokenValue;
    }
  }

  constructor(@Inject(WINDOW) private _window: Window) {}
}
